<script>
    import { Link } from "svelte-routing";
    let isTecnico = sessionStorage.getItem('isTecnico');
</script>

<main>
    <div class="container">
        <div>
            <div class="d-grid gap-2 col-10 mx-auto">
                <!--<Link
                    to="/clients"
                    style="text-decoration: none; color: black">
                    <button class="btn btn-primary btn-block" type="button">
                        Consulta de clientes
                    </button>
                </Link>
                <br>-->
                
                <Link
                    to="/stock"
                    style="text-decoration: none; color: black">
                    <button class="btn btn-primary btn-block" type="button">
                        Baixa de materiais B2C
                    </button>
                </Link>
                
                {#if isTecnico == 0}
                <br>
                <Link
                    to="/reports"
                    style="text-decoration: none; color: black">
                    <button class="btn btn-primary btn-block" type="button">
                        Relatórios B2C
                    </button>
                </Link>
                <br>
                <Link
                    to="/importrecords"
                    style="text-decoration: none; color: black">
                    <button class="btn btn-primary btn-block" type="button">
                        Importação de registros - SAP
                    </button>
                </Link>
                <br>
                <Link
                    to="/reportsB2B"
                    style="text-decoration: none; color: black">
                    <button class="btn btn-primary btn-block" type="button">
                        Relatórios B2B / O&M / PARCEIROS
                    </button>
                </Link>
                {/if}
                <br>
                <Link
                    to="/stockb2b"
                    style="text-decoration: none; color: black">
                    <button class="btn btn-primary btn-block" type="button">
                        Baixa de material - B2B / MANUTENÇÃO / PARCEIRA (Sistema ATRIX)
                    </button>
                </Link>
                <!-- <br>
                <Link
                    to="/Stockb2bOtrs"
                    style="text-decoration: none; color: black">
                    <button class="btn btn-primary btn-block" type="button">
                        Baixa de material - MANUTENÇÃO / PARCEIRA (Sistema OTRS)
                    </button>
                </Link> -->
                <br>
                <Link
                    to="/Stockb2bOfficeTrack"
                    style="text-decoration: none; color: black">
                    <button class="btn btn-primary btn-block" type="button">
                        Baixa de material - MANUTENÇÃO / PARCEIRA (Sistema OFFICE TRACK)
                    </button>
                </Link>
            </div>
        </div>
    </div>
</main>
